import { render, staticRenderFns } from "./JsaList.vue?vue&type=template&id=35323e58"
import script from "./JsaList.vue?vue&type=script&lang=js"
export * from "./JsaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports